import { z } from "zod";
import { parsePhoneNumberFromString } from "libphonenumber-js/max";

type PhoneValidationMessages = {
  required: string;
  invalid: string;
};

const PHONE_CHARACTERS = /^\+?[\d\s().\-/]+$/;

export const createPhoneSchema = (messages: PhoneValidationMessages) =>
  z
    .string({ required_error: messages.required })
    .trim()
    .min(1, messages.required)
    .refine((value) => {
      if (!value) return true; // Keep the required-field error as the only empty-value error.
      if (!PHONE_CHARACTERS.test(value)) return false;

      const normalized = value.replace(/[\s().\-/]/g, "");
      return parsePhoneNumberFromString(normalized, "BE")?.isValid() === true;
    }, messages.invalid);
